// Banner de anomalías del mockup y su modal, con las DOS reglas que hoy tienen dato.
//
// La tercera del mock —un motivo de rechazo que sube más de 10 pp— necesita los rechazos del motor
// por ventana, que no se sirven. No se pinta ni se aproxima: se dice al pie de la pantalla.
import { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Modal } from '@/kit';
import { formatUnits } from '../lib/originationMetrics';
import type { OriginationAnomaly } from '../lib/originationCohort';

/** El texto del banner. Sin anomalías no se pinta nada: el silencio ya dice que todo va bien. */
function bannerText(count: number): string {
    return count === 1 ? '1 anomalía detectada' : `${formatUnits(count)} anomalías detectadas`;
}

export function OriginationAnomalies({
    anomalies,
    onSelectStore,
}: {
    anomalies: OriginationAnomaly[];
    onSelectStore: (storeId: string) => void;
}) {
    const [open, setOpen] = useState(false);
    if (anomalies.length === 0) return null;

    return (
        <>
            <button
                type="button"
                onClick={() => {
                    setOpen(true);
                }}
                className="col-span-2 flex items-center gap-1.5 rounded-md border border-destructive bg-destructive/10 px-2.5 py-1.5 text-left text-[10.5px] font-semibold text-foreground transition-colors hover:bg-destructive/15"
            >
                <AlertTriangle className="size-3 flex-none text-destructive" aria-hidden />
                <span>{bannerText(anomalies.length)}</span>
                <span className="ml-auto text-[10px] font-normal text-muted-foreground">
                    Ver detalle →
                </span>
            </button>

            <Modal
                isOpen={open}
                onClose={() => {
                    setOpen(false);
                }}
                title="Anomalías detectadas en la ventana"
                description="Cambios fuera del patrón contra la ventana anterior. Al elegir una, su tienda queda resaltada en el scatter."
                size="lg"
            >
                <ul className="flex max-h-[52vh] flex-col gap-1.5 overflow-y-auto">
                    {anomalies.map((anomaly) => (
                        <li key={anomaly.key}>
                            <button
                                type="button"
                                onClick={() => {
                                    onSelectStore(anomaly.storeId);
                                    setOpen(false);
                                }}
                                className="flex w-full items-start gap-2 rounded-md border border-destructive/40 bg-destructive/5 px-2.5 py-2 text-left transition-colors hover:bg-destructive/10"
                            >
                                <AlertTriangle
                                    className="mt-px size-3.5 flex-none text-destructive"
                                    aria-hidden
                                />
                                <span className="min-w-0">
                                    <span className="block text-[12px] font-semibold leading-snug">
                                        {anomaly.title}
                                    </span>
                                    <span className="block text-[11px] leading-snug text-muted-foreground">
                                        {anomaly.detail}
                                    </span>
                                </span>
                                <span className="ml-auto flex-none self-center text-[10.5px] text-muted-foreground">
                                    Ver en el scatter →
                                </span>
                            </button>
                        </li>
                    ))}
                </ul>
                <p className="mt-2 text-[10.5px] italic leading-relaxed text-muted-foreground">
                    La tercera regla del mockup —un motivo de rechazo del motor que sube más de 10
                    pp— necesita los rechazos por ventana, que todavía no se sirven: esas anomalías
                    no se están detectando.
                </p>
            </Modal>
        </>
    );
}
